import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../application-core/constants';
import Unsaved from './Unsaved';
import Tooltip from '@material-ui/core/Tooltip';
import FlagIcon from '@material-ui/icons/OutlinedFlag';
import GS from '../grafsync/grafsync';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import IdentifierDialog from './IdentifierDialog';
import { globalStyles } from './style/gstheme';

const styles = Object.assign({}, globalStyles);

class Identifier extends React.PureComponent {

    state = {
        processingEdits: false,
        newIRI: null
    };

    changeIRI = (iri, fold) => {
        GS.insert(this.props.identifier, this.props.graph, "iri", iri, fold);
        if (fold) {
            this.setState({ processingEdits: true, newIRI: iri });
        }
    };

    onCompleteOutstandingEdits = () => {
        this.setState({ processingEdits: false });
        GS.operate("foldiris", this.props.graph);
        // Need to redirect to new URL
        let link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/taxonomy#project='
            + this.props.project + "&taxonomy=" + this.props.baseIRI;
        if (this.props.type === "Label") {
            link += "&view=label";
        }
        else {
            link += "&view=concept";
        }
        // We have to go to the taxonomy to avoid issues with loading the changed resource
        this.props.history.push(link);
    };

    render() {

        const { classes, label, identifier, dataTest, isReadOnly, graph, baseIRI, currentIRI } = this.props;

        const icon = !isReadOnly ?
            !isReadOnly && <IdentifierDialog
                changeIRI={this.changeIRI}
                currentIRI={currentIRI}
                classIRI={this.props.type === "Label" ?
                    "http://www.w3.org/2008/05/skos-xl#Label"
                    :
                    "http://www.w3.org/2004/02/skos/core#Concept"
                }
                graph={graph}
                baseIRI={baseIRI} />
            :
            null;
        const styleClass = isReadOnly ? classes.basicReadField : classes.inputLabel;

        return (
            <React.Fragment>
                <TextField
                    margin="dense"
                    value={currentIRI}
                    variant="outlined"
                    label={label}
                    fullWidth={true}
                    style={{ marginTop: '0px' }}
                    InputProps={{
                        inputProps: {
                            "data-test": dataTest
                        },
                        className: styleClass,
                        classes: {
                            input: styleClass
                        },
                        readOnly: true,
                        startAdornment:
                            identifier !== currentIRI ?
                                <Tooltip placement="right" title='This IRI has been changed from the original'>
                                    <FlagIcon data-test="flag" style={{ paddingRight: 10, color: '#808080' }} />
                                </Tooltip>
                                :
                                null
                        ,
                        endAdornment: icon
                    }
                    } />
                {this.state.processingEdits && <Unsaved onDone={this.onCompleteOutstandingEdits} />}
            </React.Fragment>
        );
    }
}

Identifier.defaultProps = {
    fullWidth: false,
    isReadOnly: false
};

Identifier.propTypes = {
    currentIRI: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    project: PropTypes.string,
    baseIRI: PropTypes.string,
    type: PropTypes.any,
    dataTest: PropTypes.string,
    identifier: PropTypes.string.isRequired,
    history: PropTypes.object,
    label: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(Identifier));